export const getNodeCanvasPosition = (
  nodeId: string,
  network: any
): { x: number; y: number } => {
  try {
    const { [nodeId]: nodePosition } = network.getPositions([nodeId]);
    return nodePosition;
  } catch (_err) {
    return { x: 0, y: 0 };
  }
};

export const getNodeDomPosition = (
  nodeId: string,
  network: any
): { x: number; y: number } => {
  try {
    const nodePosition = getNodeCanvasPosition(nodeId, network);
    const { top } = network.getBoundingBox(nodeId);
    const position = network.canvasToDOM({ x: nodePosition.x, y: top });
    return position;
  } catch (_err) {
    return { x: 0, y: 0 };
  }
};
